import * as React from 'react';
import * as _ from 'underscore';

export default class EditViewValidationMixin {
    private component: React.Component<any, any>;

    constructor(c: React.Component<any, any>) {
        this.component = c;
    }

    public validateFields(obj, params?): boolean {
        if (params == null) {
            params = this.component.state;
        }

        return EditViewValidationMixin.validateFields(obj, params);
    }

    public static validateFields(obj, params): boolean {
        let find = _.find(
            _.keys(obj),

            (key) => {
                let param: any = params[key];

                if (param == null) {
                    return false;
                }

                param.validate(obj[key]);

                return param.errors.length !== 0;
            }
        );

        return find == null;
    }
}
